/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useElementForkRef } from '@cian/react-utils';
import { Popper } from '../../../internal/components/Popper';
import { PREVENT_OVERFLOW, FLIP } from '../../../internal/components/Popper/modifiers';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонента для открытия выпадающего контента с привязкой к элементу
 */
export function Popover(props) {
  const {
    open,
    content,
    preventOverflow,
    flip,
    placement
  } = props;
  const [refferedChildren, childrenRef] = useElementForkRef(props.children);
  const modifiers = React.useMemo(() => {
    return [flip && FLIP, preventOverflow && PREVENT_OVERFLOW].filter(Boolean);
  }, [flip, preventOverflow]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [refferedChildren, /*#__PURE__*/_jsx(Popper, {
      open: open,
      anchorRef: childrenRef,
      placement: placement,
      modifiers: modifiers,
      children: content
    })]
  });
}